<script>
    import {fetchUserRecents} from '@js/actions/userActions';

    import RideCard from '@js/components/ride/RideCard.svelte';

    const {
        class: className,
        title
    } = $props();

    let plannedRides = $state([]);

    const _loadPlannedRides = () => {
        if (!window.currentUserId) {
            return;
        }

        fetchUserRecents(window.currentUserId)
            .then((result) => {
                plannedRides = [
                    ...(result.planned?.rides || []),
                    ...(result.poi_planned?.rides || [])
                ];
            });
    };

    _loadPlannedRides();
</script>

{#if plannedRides.length > 0}
    <div class={className}>
        <h2 class="text-3xl mb-6 text-center">
            {title}
        </h2>

        <div class="row">
            {#each plannedRides as ride (ride.id)}
                <div class="col s12 m6 l4">
                    <RideCard ride={ride}/>
                </div>
            {/each}
        </div>
    </div>
{/if}
